'use client'
import React from 'react'

export const IndentDecreaseIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 5H10.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.5 10H10.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.5 15H17.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12.25 7.25L17.25 3.75V10.75L12.25 7.25Z" fill="currentColor" />
  </svg>
)
